/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waiting_On_ApproversInputs */

const en_waiting_on_approvers = /** @type {(inputs: Waiting_On_ApproversInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting on who decides`)
};

/**
* | output |
* | --- |
* | "Waiting on who decides" |
*
* @param {Waiting_On_ApproversInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const waiting_on_approvers = /** @type {((inputs?: Waiting_On_ApproversInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waiting_On_ApproversInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_waiting_on_approvers(inputs)
});